<template lang="pug">
    div
        Card.a8-page-description-card
            Row(type="flex" align="middle" justify="space-between")
                Col(span="6")
                    div
                        h2 {{ $t('slbsetting.pageTitleText') }}
                        p Manage your registered SLB.
                Col
                    ExplainBtn(:objectExplanation="objectsExplanation")
        RcmTable(
            :esIndex="esIndex"
            :esIndexFields="esIndexFields"
            :addButtonText="addButtonText"
            :userCanCreate="false"
            :userCanIndex="true"
            :userCanDelete="true"
            :drawerTitleKey="drawerTitleKey"
            :sort="sort"
            ref="rcmTable"
            :viewSlotInfo="viewSlotInfo"
            :searchView="$options.name"
            :sectionInfo="sectionInfo"
            primarySearchKey="hostname"
            :primarySearchKeyI18="$t('slbsetting.hostname')"
            :isCreateBtnDisabled="!$can('write', 'groupResourcesPermission','SlbsManage')"
            :isEditBtnDisabled="!$can('write', 'groupResourcesPermission','SlbsManage')"
            :isDeleteBtnDisabled="!$can('write', 'groupResourcesPermission','SlbsManage')"
            :isRestartBtnDisabled="!$can('write', 'groupResourcesPermission','SlbsManage')"
            @passSourceNatBoolean="sourceNatBoolean=$event"
        )
            template(slot="tableUpperBtn" v-if="isAllowGroupUserRegisterSLB && $can('write', 'groupResourcesPermission','SlbsManage')")
                Button(type="primary" @click="isRegistrationInfoShown=true") {{$t('rcmtable.registrationText')}}
        RegisterNodeInfoModal(:nodeType="nodeType" :isRegistrationInfoShown="isRegistrationInfoShown" :hasPermission="isAllowGroupUserRegisterSLB" @closeRegisterInfoModal="isRegistrationInfoShown = false")
        SourceNatModal(:isSourceNatModalShown="!sourceNatBoolean" @closeSourceNatModal="isSourceNatModalShown = false")
</template>
<script>
import Vue from "vue";
Vue.component("TagList", TagList);
Vue.component("LineOptimize", LineOptimize);

import RcmTable from "@/components/RcmTable_v2";
import TagList from "@/components/TagList";
import LineOptimize from "@/components/SlbSetting/LineOptimize";
import bus from "@/libs/bus.js";
import { getRegionInfo } from "@/api/3rd/17ce.js";
import CreateSlbBtn from "@/components/SlbSetting/CreateSlbBtn";
import JsonPoptip from "@/components/JsonPoptip";
import ObjectLogBtn from "@/components/ObjectLogBtn";
import CopyText from "@/components/CopyText";
import RegisterNodeInfoModal from "@/components/NodeRegisteration/RegisterNodeInfoModal";
import SourceNatModal from "@/components/SourceNatModal";

Vue.component("JsonPoptip", JsonPoptip);
Vue.component("ObjectLogBtn", ObjectLogBtn);
Vue.component("CopyText", CopyText);

import ExplainPrivateKeys from "@/components/PoptipInfos/ExplainPrivateKeys";
Vue.component("ExplainPrivateKeys", ExplainPrivateKeys);

import NodeConnectBtn from "@/components/NodeConnectBtn";
Vue.component("NodeConnectBtn", NodeConnectBtn);

import {
    settingZoneExplain,
    groupName,
    serviceIP,
    isEnabled,
    connectState,
    hostName,
    edges,
    line,
    action,
} from "./fields.js";

export default {
    name: "SlbSetting",
    components: {
        RcmTable,
        TagList,
        LineOptimize,
        CreateSlbBtn,
        RegisterNodeInfoModal,
        SourceNatModal,
    },
    data() {
        return {
            nodeType: "slb",
            isRegistrationInfoShown: false,
            viewSlotInfo: {
                slbclients: [],
            },
            esIndex: "rcm-slbs",
            drawerTitleKey: "hostname",
            sort: [{ modifiedDate: { order: "desc" } }],
            objectsExplanation: {},
            sourceNatBoolean: true,
        };
    },
    computed: {
        isAllowGroupUserRegisterSLB() {
            return this.$store.state.platformPlan.multiTenancyConfigs.isAllowGroupUserRegisterSLB
                ? this.$store.state.platformPlan.multiTenancyConfigs.isAllowGroupUserRegisterSLB
                : false;
        },
        addButtonText() {
            return this.$i18n.t("slbsetting.createText");
        },
        sectionInfo() {
            let sectionInfo = [
                { sectionKey: "essential", isOpened: true },
                { sectionKey: "healthCheck", isOpened: false },
                { sectionKey: "advanced", isOpened: false },
                { sectionKey: "node_connect", isOpened: false },
            ];

            sectionInfo = sectionInfo.map((e) => {
                e.sectionName = this.$i18n.t(`global.formSections.${e.sectionKey}`);
                return e;
            });

            return sectionInfo;
        },
        esIndexFields() {
            return this.$store.getters.isAdmin
                ? {
                      action: action(this),
                    //   nodeConnect: {
                    //       render: (h, params) => {
                    //           return h(
                    //               "NodeConnectBtn",
                    //               {
                    //                   props: {
                    //                       nodeType: "slb",
                    //                       hostname: params.row.hostname,
                    //                       sshKeyName: params.row.nodeConnectSSHKey,
                    //                       sshUser: params.row.nodeConnectSSHUser,
                    //                       sshHost: params.row.nodeConnectSSHHost || params.row.externalIP,
                    //                       sshPort: params.row.nodeConnectSSHPort,
                    //                   },
                    //               },
                    //               ""
                    //           );
                    //       },
                    //   },
                      settingZoneExplain: settingZoneExplain(this),
                      groupName: groupName(this),
                      hostname: hostName(this),
                      _id: {},
                      runningStat: {},
                      isenabled: isEnabled(this),
                      isEnableProxyProtocolFromClient: {},
                      isEnableProxyProtocol: {},
                      edges: edges(this),
                      internalIP: {},
                      externalIP: {},
                      recordType: { sectionKey: "essential" },
                      serviceIP: serviceIP(this),
                      isDummySlb: {},
                      lineOptimize: {},
                      line: line(this),
                      serviceProvideType: {},
                      externalCheckInfo: {},
                      isEnabledExternalCheck: {},
                      checkTimesAsHealthy: {},
                      checkTimesAsUnhealthy: {},
                      usedHealthCheckProbes: {},
                      externalCheckUrl: {},
                      sourceNat: {},
                      slbSourceIpPool: {},
                      connectState: connectState(this),
                      gitSlbSuccess: {},
                      outgoingRate: {},
                      slbMasterIsRunning: {},
                      //   speedLimit: {},
                      //   ipWhiteList: {},
                      //   ipBlackList: {},
                      errMsg: {},
                      nodeConnectSSHKey: {},
                      nodeConnectSSHUser: {},
                      nodeConnectSSHHost: {},
                      nodeConnectSSHPort: {},
                      status: {},
                      objectLog: {},
                  }
                : {
                      action: action(this),
                      settingZoneExplain: settingZoneExplain(this),
                      groupName: groupName(this),
                      hostname: hostName(this),
                      _id: {},
                      runningStat: {},
                      isenabled: isEnabled(this),
                      isEnableProxyProtocolFromClient: {},
                      isEnableProxyProtocol: {},
                      edges: edges(this),
                      internalIP: {},
                      externalIP: {},
                      recordType: { sectionKey: "essential" },
                      serviceIP: serviceIP(this),
                      isDummySlb: {},
                      lineOptimize: {},
                      line: line(this),
                      serviceProvideType: { withForm: false },
                      // externalCheckInfo: {},
                      // isEnabledExternalCheck: {},
                      // checkTimesAsHealthy: {},
                      // checkTimesAsUnhealthy: {},
                      // usedHealthCheckProbes: {},
                      // externalCheckUrl: {},
                      sourceNat: {},
                      slbSourceIpPool: {},
                      connectState: connectState(this),
                      gitSlbSuccess: {},
                      outgoingRate: {},
                      slbMasterIsRunning:{},
                      //   speedLimit: {},
                      //   ipWhiteList: {},
                      //   ipBlackList: {},
                      errMsg: {},
                      status: {},
                      objectLog: {},
                  };
        },
    },
    watch: {
        "$i18n.locale": {
            deep: true,
            handler: function () {
                this.objectsExplanation = this.$i18n.t("objectExplanation." + this.esIndex);
            },
        },
    },
    methods: {},
    async mounted() {
        this.$socket.emit("getslbclients");
        if (this.$store.state.backendData.thirdParty.lineOptimize.regionInfo.length == 0) {
            getRegionInfo().then((res) => {
                this.$store.commit("SET_REGION_INFO", res.data.data);
            });
        }
    },
    sockets: {
        updateslbclients: function (clients) {
            this.viewSlotInfo.slbclients = clients;
        },
    },
    created() {
        this.objectsExplanation = this.$i18n.t("objectExplanation." + this.esIndex);
        // 監聽以自己組件為名的事件
        bus.$on(this.$options.name, (busEvent) => {
            bus.$emit(busEvent);
        });
    },
    destroyed() {},
    beforeDestroy() {
        bus.$off(this.$options.name);
    },
};
</script>
<style lang="less" scoped>
.ivu-radio-group-large .ivu-radio-border {
    height: 150px;
    .ivu-radio {
        display: none;
    }
}
.single-radio {
    display: inline-block;
    vertical-align: top;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/view/SlbSetting/Page.vue